import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getVaultsAction } from '@/shared/store/vaults/actions';

export const useRefreshVaults = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(
            getVaultsAction({
                withoutCache: true,
            }),
        );
    }, [dispatch]);
};
